import "./CBXLoader.css"; // You'll create this CSS file

const Loader = () => {
  return (
    <div className='cbx-loader-wrapper'>
      <div className='cbx-loader-content'>
        <h1 className='cbx-title'>CBX</h1>
        <p className='cbx-subtitle'>Core Banking eXperience</p>
        <div className='cbx-bounce-dots'>
          <div className='dot dot1'></div>
          <div className='dot dot2'></div>
          <div className='dot dot3'></div>
        </div>
      </div>
      <p className='cbx-footer'>Powered by RosoftSavvy</p>
    </div>
  );
};

export default Loader;
